import { Button, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { IInvoice } from 'src/types/invoice';

interface Props {
    original: IInvoice;
    filters: any;
    persistInvoice: (params: any, arr: any, res: any) => void;
}

const ReadyDoeInvoice: React.FunctionComponent<Props> = ({ original, filters, persistInvoice }: Props) => {
    const [opened, setOpened] = useState(false);
    const handleClose = () => {
        setOpened(false);
    };
    const varObj: any = {
        0: (
            <div className={'d-flex w-100  border border-secondary rounded'}>
                <button className={'bg-danger w-100 rounded text-white'} type="button" onClick={() => setOpened(true)}>
                    NO
                </button>
            </div>
        ),
        1: (
            <div className={'d-flex w-100 border border-secondary rounded'}>
                <button className={'bg-primary w-100 rounded text-white'} type="button" onClick={() => setOpened(true)}>
                    YES
                </button>
            </div>
        ),
    };
    return (
        <>
            <div>{varObj[+!!original?.isReadyToSent]}</div>

            <Modal show={opened} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to change?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() =>
                            persistInvoice(
                                {
                                    isReadyToSent: !original.isReadyToSent,
                                    RequestSent: true,
                                    id: original.id ? +original.id : 1,
                                },
                                [],
                                {
                                    resolve: () => {
                                        toast.success('Invoice successfully changed!');
                                        handleClose();
                                    },
                                    reject: (reason: any) => {
                                        toast.error(reason);
                                        handleClose();
                                    },
                                },
                            )
                        }
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ReadyDoeInvoice;
